package io.jsonize.web.services

interface PlatformStorage {
    suspend fun save(key: String, data: String)
    suspend fun load(key: String): String?

    companion object {
        // Provided for easy default wiring in shared ViewModel
        lateinit var default: PlatformStorage
    }
}
